import { baseUrl } from '../network'

export const whoAmIUrl = baseUrl + 'api/whoami'
export const navbarUrl = (companyId: number) => baseUrl + `api/user/navbar/company/${companyId}`
export const updateStatusUrl = baseUrl + 'api/profile/updateStatus'
export const refreshUrl = baseUrl + 'api/refresh'
export const contactsUrl = baseUrl + 'api/contacts'